import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Stack, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { Title } from "react-head";

import HeaderBarcode from "../../../shared/HeaderBarcode/HeaderBarcode";
import FooterBarcode from "../../../shared/FooterBarcode/FooterBarcode";

import "./ClueboardBase.scss";

const ClueboardBase = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        navigate(-1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  return (
    <>
      <Title>Clueboard</Title>
      <Stack className={`clueboard-parent`}>
        <Stack className="dotted-background">
          <Stack direction={"column"} className="container header">
            <HeaderBarcode />
            <IconButton
              className="btn btn-back btn-sm"
              variant="contained"
              onClick={() => navigate(-1)}
            >
              <ArrowBack size={20} />
              <span> Go Back (esc)</span>
            </IconButton>
          </Stack>
          <Stack direction="row" className={`container content  `}>
            {children}
          </Stack>
          <Stack direction="row" className="container">
            <FooterBarcode />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default ClueboardBase;
